/*
  Helper function for looping through an object's properties.
*/
const objEach = (obj, callback) => {
  if (!obj) return;

  Object.keys(obj).forEach(key => {
    callback(key, obj[key]);
  });
};

/*
  Returns a cell in the table:
    {
      break: 1,
      price: 12
    }
*/
const _pricingTablePriceBreak = (priceBreak, price) => {
  return {
    break: parseInt(priceBreak, 10),
    price: price,
  };
}

/*
  Returns a product row in the table:
    {
      title: '4x6 (Glossy)',
      delivery_prices: {
        del_opt_1: [
          { break: 1, price: 12 },
          { break: 51, price: 42 },
          { break: 101, price: 32 },
        ],
        ...
      },
      ...
    }
*/
const _pricingTableRow = (productsOfSize, productsPricesOfSize) => {
  return {
    title: productsOfSize[0].title,
    delivery_prices: _productPricesToPricingTablePrices(productsPricesOfSize)
  }
};

/*
  Transforms the product's prices data structure:
    {
      del_opt_1: {
        1: 12,
        51: 42,
        101: 32
      },
      del_opt_2: {
        1: 22,
        21: 19,
        31: 14,
        101: 11
      }
    }
  into the PricingTable data structure:
    {
      del_opt_1: [
        { break: 1, price: 12 },
        { break: 51, price: 42 },
        { break: 101, price: 32 }
      ],
      del_opt_2: [
        { break: 1, price: 22 },
        { break: 21, price: 19 },
        { break: 31, price: 14 },
        { break: 101, price: 11 }
      ]
    }
*/
const _productPricesToPricingTablePrices = (productPrices) => {
  const list = {};

  objEach(productPrices, (deliveryOption, prices) => {
    list[deliveryOption] || (list[deliveryOption] = []);

    objEach(prices, (priceBreak, price) => {
      list[deliveryOption].push(_pricingTablePriceBreak(priceBreak, price));
    });
  });

  return list;
}

/*
  Merge together the prices from a list of products.
  The "winner" is the highest price of a break for the delivery option.
  The result will have all delivery options and all that DO's price breaks.
*/
const _bestPricesOfProducts = (products) => {
  const bestPrices = {};

  products.map(product => {
    product.options.delivery_options.forEach(deliveryOption => {
      bestPrices[deliveryOption] || (bestPrices[deliveryOption] = {});

      objEach(product.prices[deliveryOption], (priceBreak, price) => {
        if (!bestPrices[deliveryOption][priceBreak] ||
          bestPrices[deliveryOption][priceBreak] < price) {
          bestPrices[deliveryOption][priceBreak] = price;
        }
      });
    });
  });

  return bestPrices;
};

/*
  Returns the PricingTable data structure for a list of Print products.
  Each row is a product, each column is a delivery option, each cell a price break.
*/
const pricingTableData = (allProducts) => {
  const allProductsBySize = allProducts.reduce((list, product) => {
    const id = product.size_id;

    list[id] || (list[id] = []);
    list[id].push(product);

    return list;
  }, {});

  return Object.values(allProductsBySize).map(productsOfSize => {
    const productsPricesOfSize = _bestPricesOfProducts(productsOfSize);

    return _pricingTableRow(productsOfSize, productsPricesOfSize);
  });
};

export {
  pricingTableData,

  _bestPricesOfProducts,
  _productPricesToPricingTablePrices
};
